const SET_FILTER_DATA = 'user/SET_FILTER_DATA';

export { SET_FILTER_DATA };
